import ApprovedCollectionDetail from './ApprovedCollectionDetail';

export default ApprovedCollectionDetail;
